import { IBackgroundImage } from '../components';
import { Floor } from '@jooxter/api';
import { IFloorPlanBooking, IFloorPlanResource } from '../components/JxtFloorPlan/types';
import { IVector2D } from '../types/positioning.types';

export type TCreateBackgroundImageFn = (
  imageSrc: string,
  onload: (i?: IBackgroundImage) => void,
  dimensions?: { width: number; height: number }
) => () => void;

export enum FloorPlanPictoTypeEnum {
  ResourceHeatmap = 'resource-heatmap',
  ResourceState = 'resource-state',
  Avatar = 'avatar',
  Pin = 'pin',
}

export interface IBaseUseFloorPlan {
  resources: IFloorPlanResource[];
  width: number;
  floorPlan: Floor;
  type: FloorPlanPictoTypeEnum;
  bookings?: IFloorPlanBooking[];
}

export interface IUseFloorPlanWithUsers extends IBaseUseFloorPlan {
  type: FloorPlanPictoTypeEnum.Avatar;
  bookings: IFloorPlanBooking[];
}

export interface IUseFloorPlanWithBookings extends IBaseUseFloorPlan {
  type: FloorPlanPictoTypeEnum.Pin;
  bookings: IFloorPlanBooking[];
}

export type IUseFloorPlan = IUseFloorPlanWithBookings | IUseFloorPlanWithUsers | IBaseUseFloorPlan;

export interface IUsePictosGenerator {
  width: number;
  resources: IFloorPlanResource[];
  bookings?: IFloorPlanBooking[];
  floorPlan: Floor;
  locateResourceId: (id: number) => IVector2D | undefined;
  backgroundImage?: HTMLImageElement;
  fixedPictoSize?: boolean;
}
